/*
 * MDB shim for MDBCloseIcon
 * Files currently importing this symbol from "mdbreact":
 * - src/Seating/Patient/PatientViewComponents/patientInformationTab.jsx
 * - src/Seating/Patient/PatientViewComponents/pverifyModal.jsx
 */

export default function MDBCloseIcon(props) {
  return (
    <span aria-hidden="true" {...props}>
      ×
    </span>
  );
}
